(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-alcantara-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.aal').forEach(function (root) {
      if (root.dataset.aalInit) return;
      root.dataset.aalInit = '1';

      var variants = JSON.parse(root.querySelector('[data-aal-variants]').textContent);

      var scenes = root.querySelectorAll('[data-aal-slide]');
      var thumbs = root.querySelectorAll('[data-aal-thumb]');
      function loadScene(i) {
        var scene = root.querySelector('[data-aal-slide="' + i + '"]');
        var img = scene && scene.querySelector('img[data-aal-src]');
        if (!img) return;
        img.src = img.dataset.aalSrc;
        delete img.dataset.aalSrc;
      }
      function showSlide(i) {
        loadScene(i);
        scenes.forEach(function (s) { s.classList.toggle('is-active', s.dataset.aalSlide === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.aalThumb === String(i)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.dataset.aalThumb); }); });
      function showSlideForImageUrl(url) {
        if (!url) return;
        var target = null;
        scenes.forEach(function (s) {
          var img = s.querySelector('img');
          if (img && (img.src === url || img.dataset.aalSrc === url)) target = s.dataset.aalSlide;
        });
        if (target !== null) showSlide(target);
      }

      var qtyVal = root.querySelector('[data-aal-qty-val]');
      var qtyInput = root.querySelector('[data-aal-qty-input]');
      function setQty(n) {
        n = Math.max(1, Math.min(99, n));
        if (qtyVal) qtyVal.textContent = n;
        if (qtyInput) qtyInput.value = n;
      }
      var minus = root.querySelector('[data-aal-qty-minus]');
      var plus = root.querySelector('[data-aal-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) + 1); });

      var selectedColor = root.querySelector('.aal-swatch.is-active');
      selectedColor = selectedColor ? selectedColor.dataset.aalSwatch : variants[0].title;

      var formVariantId = root.querySelector('[data-aal-form-variant-id]');
      var priceEl = root.querySelector('[data-aal-price]');
      var compareEl = root.querySelector('[data-aal-compare]');
      var saveEl = root.querySelector('[data-aal-save]');
      var colorLabel = root.querySelector('[data-aal-color-label]');
      var addBtn = root.querySelector('[data-aal-add-btn]');

      function money(cents) { return '$' + (cents / 100).toFixed(2); }

      function applyVariant() {
        var match = variants.find(function (v) { return v.title === selectedColor; });
        if (!match) return;
        if (formVariantId) formVariantId.value = match.id;
        if (colorLabel) colorLabel.textContent = selectedColor;
        if (priceEl) priceEl.textContent = money(match.price);
        if (match.compareAtPrice && parseFloat(match.compareAtPrice) > parseFloat(match.price)) {
          if (compareEl) { compareEl.textContent = money(match.compareAtPrice); compareEl.hidden = false; }
          if (saveEl) {
            var pct = Math.round((match.compareAtPrice - match.price) / match.compareAtPrice * 100);
            saveEl.textContent = 'Save ' + pct + '%'; saveEl.hidden = false;
          }
        } else {
          if (compareEl) compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
        if (addBtn) addBtn.disabled = !match.available;
        showSlideForImageUrl(match.image);
      }

      root.querySelectorAll('[data-aal-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedColor = btn.dataset.aalSwatch;
          root.querySelectorAll('[data-aal-swatch]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyVariant();
        });
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-autocover-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ac-root]').forEach(function (root) {
    if (root.dataset.acInit) return; root.dataset.acInit = '1';

    /* ---- gallery: snap track + thumbs ---- */
    var track = root.querySelector('[data-ac-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ac-thumb]'));
    function setThumb(i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); var on = thumbs[i]; if (on && on.scrollIntoView) on.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = +t.dataset.acThumb; var s = track.children[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); setThumb(i); }); });
    if (track && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > .6) setThumb(+e.target.dataset.acSlide); }); }, { root: track, threshold: [.6] });
      Array.prototype.forEach.call(track.children, function (s) { io.observe(s); });
    }

    /* ---- colour swatches: variant id, price, gallery jump ---- */
    var vid = root.querySelector('[data-ac-variant-id]'), priceEl = root.querySelector('[data-ac-price]'), cmpEl = root.querySelector('[data-ac-compare]'), saveEl = root.querySelector('[data-ac-save]'), nameEl = root.querySelector('[data-ac-colour-name]'), stickyPrice = root.querySelector('[data-ac-sticky-price]');
    root.querySelectorAll('[data-ac-swatch]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-ac-swatch]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        if (vid) vid.value = b.dataset.id; if (nameEl) nameEl.textContent = b.dataset.name;
        if (priceEl) priceEl.textContent = b.dataset.price; if (stickyPrice) stickyPrice.textContent = b.dataset.price; var sc = root.querySelector('[data-ac-sticky-colour]'); if (sc) sc.textContent = b.dataset.name;
        var show = !!b.dataset.showCompare; if (cmpEl) { cmpEl.hidden = !show; cmpEl.textContent = b.dataset.compare; } if (saveEl) { saveEl.hidden = !show; saveEl.textContent = b.dataset.save; }
        var i = +b.dataset.media, s = track && track.children[i]; if (s) { track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); setThumb(i); }
        try { var u = new URL(location.href); u.searchParams.set('variant', b.dataset.id); history.replaceState(null, '', u); } catch (e) {}
      });
    });

    /* ---- quantity ---- */
    var qtyIn = root.querySelector('[data-ac-qty-input]'), qtyVal = root.querySelector('[data-ac-qty-val]');
    root.querySelectorAll('[data-ac-qty]').forEach(function (b) { b.addEventListener('click', function () { var n = Math.max(1, Math.min(10, (+qtyIn.value || 1) + (+b.dataset.acQty))); qtyIn.value = n; qtyVal.textContent = n; }); });

    /* ---- fitment gate: same window-capture trick as the AutoShade page ---- */
    var fit = root.querySelector('[data-ac-fit]'), fitIn = root.querySelector('[data-ac-fit-input]'), fitErr = root.querySelector('[data-ac-fit-err]');
    function fitOk() { return !fitIn || fitIn.value.replace(/\s+/g, ' ').trim().length >= 3; }
    function fitFail() { fit.classList.add('is-invalid'); fitErr.hidden = false; fitIn.focus({ preventScroll: true }); fitIn.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    if (fitIn) {
      fitIn.addEventListener('input', function () { if (fitOk()) { fit.classList.remove('is-invalid'); fitErr.hidden = true; } });
      fitIn.addEventListener('invalid', function (e) { e.preventDefault(); fitFail(); });
      window.addEventListener('submit', function (e) { if (e.target !== fitIn.form || fitOk()) return; e.preventDefault(); e.stopImmediatePropagation(); fitFail(); }, true);
    }

    /* ---- scroll-to-buy buttons + sticky bar ---- */
    var addBtn = root.querySelector('[data-ac-add]'), buy = root.querySelector('[data-ac-buy]');
    root.querySelectorAll('[data-ac-scroll-fit]').forEach(function (b) { b.addEventListener('click', function () { buy.scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(function () { if (fitIn) fitIn.focus({ preventScroll: true }); }, 500); }); });
    root.querySelectorAll('[data-ac-scroll-colour]').forEach(function (b) { b.addEventListener('click', function () { var c = root.querySelector('.ac-colour') || buy; c.scrollIntoView({ behavior: 'smooth', block: 'center' }); }); });
    var sticky = root.querySelector('[data-ac-sticky]'), stickyBtn = root.querySelector('[data-ac-sticky-btn]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (es) { sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(addBtn);
      stickyBtn.addEventListener('click', function () { if (!fitOk()) { buy.scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(fitFail, 450); return; } addBtn.click(); });
    }

    /* ---- reels ---- */
    var reels = root.querySelectorAll('[data-ac-reel]');
    function reelLoad(v) { if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src; }
    function reelStopOthers(cur) { reels.forEach(function (r) { var v = r.querySelector('video'); if (v !== cur) { v.pause(); v.muted = true; r.classList.remove('is-playing', 'is-sound'); } }); }
    reels.forEach(function (r) {
      var v = r.querySelector('video'), b = r.querySelector('[data-ac-reel-btn]');
      b.addEventListener('click', function () {
        reelLoad(v);
        if (v.paused || v.muted) {
          reelStopOthers(v); v.muted = false; v.loop = false;
          var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
          r.classList.add('is-playing', 'is-sound');
        } else { v.pause(); r.classList.remove('is-playing', 'is-sound'); }
      });
      v.addEventListener('ended', function () { r.classList.remove('is-playing', 'is-sound'); v.muted = true; v.loop = true; });
    });
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reels.length && 'IntersectionObserver' in window && !saveData && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var r0 = reels[0], v0 = r0.querySelector('video');
      new IntersectionObserver(function (es) {
        if (r0.classList.contains('is-sound')) return;
        if (es[0].isIntersecting) { reelLoad(v0); v0.muted = true; var p = v0.play(); if (p && p.catch) p.catch(function () {}); r0.classList.add('is-playing'); }
        else { v0.pause(); r0.classList.remove('is-playing'); }
      }, { threshold: .6 }).observe(r0);
    }

    /* ---- remote demo ---- */
    var stage = root.querySelector('[data-ac-stage]'), clip = root.querySelector('[data-ac-clip]'), timer = root.querySelector('[data-ac-timer]'), state = root.querySelector('[data-ac-state]'), led = root.querySelector('[data-ac-led]');
    var tags = { 1: root.querySelector('[data-ac-tag="1"]'), 2: root.querySelector('[data-ac-tag="2"]'), 3: root.querySelector('[data-ac-tag="3"]') };
    var DUR = 5000, raf = null, prog = 0, dir = 0, t0 = 0, p0 = 0;
    function paint(p) { var w = 520 * p; clip.setAttribute('x', 320 - w / 2); clip.setAttribute('width', w); timer.textContent = (p * 10).toFixed(1); tags[1].classList.toggle('is-on', dir === 1 && p > 0 && p < 1); tags[2].classList.toggle('is-on', dir === 1 && p >= .6); tags[3].classList.toggle('is-on', p >= 1); stage.classList.toggle('is-armed', p >= 1); }
    function step(ts) { var e = ts - t0, p = Math.max(0, Math.min(1, p0 + dir * e / DUR)); prog = p; paint(p); if ((dir === 1 && p < 1) || (dir === -1 && p > 0)) { raf = requestAnimationFrame(step); } else { raf = null; led.classList.remove('is-on'); state.textContent = p >= 1 ? 'Covered · alarm armed' : 'Retracted — housing ready to lift off'; if (p <= 0) { timer.textContent = '0.0'; } } }
    function run(d, label) { if (!clip) return; cancelAnimationFrame(raf); dir = d; p0 = prog; t0 = performance.now(); led.classList.add('is-on'); state.textContent = label; raf = requestAnimationFrame(step); }
    var dep = root.querySelector('[data-ac-deploy]'), ret = root.querySelector('[data-ac-retract]');
    if (dep) dep.addEventListener('click', function () { if (prog >= 1) return; run(1, 'Deploying…'); });
    if (ret) ret.addEventListener('click', function () { if (prog <= 0) return; run(-1, 'Retracting…'); });
    if (clip) paint(0);

    /* ---- reveal ---- */
    var rev = root.querySelectorAll('.ac-row, .ac-feat__card, .ac-rev__card, .ac-tile, .ac-steps li');
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      rev.forEach(function (el) { el.classList.add('ac-reveal'); });
      var ro = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      rev.forEach(function (el) { ro.observe(el); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-charm-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ach').forEach(function (root) {
      if (root.dataset.achInit) return;
      root.dataset.achInit = '1';

      var variants = JSON.parse(root.querySelector('[data-ach-variants]').textContent);

      var scenes = root.querySelectorAll('[data-ach-slide]');
      var thumbs = root.querySelectorAll('[data-ach-thumb]');
      function loadScene(i) {
        var scene = root.querySelector('[data-ach-slide="' + i + '"]');
        var img = scene && scene.querySelector('img[data-ach-src]');
        if (!img) return;
        img.src = img.dataset.achSrc;
        delete img.dataset.achSrc;
      }
      function showSlide(i) {
        loadScene(i);
        scenes.forEach(function (s) { s.classList.toggle('is-active', s.dataset.achSlide === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.achThumb === String(i)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.dataset.achThumb); }); });
      function showSlideForImageUrl(url) {
        if (!url) return;
        var target = null;
        scenes.forEach(function (s) {
          var img = s.querySelector('img');
          if (img && (img.src === url || img.dataset.achSrc === url)) target = s.dataset.achSlide;
        });
        if (target !== null) showSlide(target);
      }

      var qtyVal = root.querySelector('[data-ach-qty-val]');
      var qtyInput = root.querySelector('[data-ach-qty-input]');
      function setQty(n) {
        n = Math.max(1, Math.min(99, n));
        if (qtyVal) qtyVal.textContent = n;
        if (qtyInput) qtyInput.value = n;
      }
      var minus = root.querySelector('[data-ach-qty-minus]');
      var plus = root.querySelector('[data-ach-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) + 1); });

      var selectedColor = root.querySelector('.ach-swatch.is-active');
      selectedColor = selectedColor ? selectedColor.dataset.achSwatch : variants[0].title;

      var formVariantId = root.querySelector('[data-ach-form-variant-id]');
      var priceEl = root.querySelector('[data-ach-price]');
      var compareEl = root.querySelector('[data-ach-compare]');
      var saveEl = root.querySelector('[data-ach-save]');
      var colorLabel = root.querySelector('[data-ach-color-label]');
      var addBtn = root.querySelector('[data-ach-add-btn]');

      function money(cents) { return '$' + (cents / 100).toFixed(2); }

      function applyVariant() {
        var match = variants.find(function (v) { return v.title === selectedColor; });
        if (!match) return;
        if (formVariantId) formVariantId.value = match.id;
        if (colorLabel) colorLabel.textContent = selectedColor;
        if (priceEl) priceEl.textContent = money(match.price);
        if (match.compareAtPrice && parseFloat(match.compareAtPrice) > parseFloat(match.price)) {
          if (compareEl) { compareEl.textContent = money(match.compareAtPrice); compareEl.hidden = false; }
          if (saveEl) {
            var pct = Math.round((match.compareAtPrice - match.price) / match.compareAtPrice * 100);
            saveEl.textContent = 'Save ' + pct + '%'; saveEl.hidden = false;
          }
        } else {
          if (compareEl) compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
        if (addBtn) addBtn.disabled = !match.available;
        showSlideForImageUrl(match.image);
      }

      root.querySelectorAll('[data-ach-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedColor = btn.dataset.achSwatch;
          root.querySelectorAll('[data-ach-swatch]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyVariant();
        });
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-cyberwheel-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.acw').forEach(function (root) {
      if (root.dataset.acwInit) return;
      root.dataset.acwInit = '1';

      var variantsEl = root.querySelector('[data-acw-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

      /* ---- reveal + stagger ---- */
      var revealEls = root.querySelectorAll('.acw-reveal, .acw-stagger');
      if ('IntersectionObserver' in window && revealEls.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px' });
        revealEls.forEach(function (el) { io.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('is-in'); });
      }

      /* ---- 3D tilt (pointer devices only) ---- */
      function attachTilt(el, opts) {
        if (!el || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        var maxTilt = (opts && opts.maxTilt) || 8;
        var scale = (opts && opts.scale) || 1.015;
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          el.style.transform = 'rotateX(' + ((0.5 - py) * maxTilt).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * maxTilt).toFixed(2) + 'deg) scale(' + scale + ')';
          el.style.setProperty('--acw-glare-x', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--acw-glare-y', (py * 100).toFixed(1) + '%');
          el.classList.add('is-tilting');
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; el.classList.remove('is-tilting'); });
      }
      attachTilt(root.querySelector('[data-acw-gallery-main]'), { maxTilt: 7, scale: 1.012 });
      root.querySelectorAll('[data-acw-tilt-card]').forEach(function (c) { attachTilt(c, { maxTilt: 6, scale: 1.03 }); });

      /* ---- gallery (deferred loads; scenes/thumbs share the same index) ---- */
      var scenes = root.querySelectorAll('[data-acw-slide]');
      var thumbs = root.querySelectorAll('[data-acw-thumb]');
      function loadScene(i) {
        var scene = root.querySelector('[data-acw-slide="' + i + '"]');
        var img = scene && scene.querySelector('img[data-acw-src]');
        if (!img) return;
        img.src = img.dataset.acwSrc;
        delete img.dataset.acwSrc;
      }
      function showSlide(i) {
        loadScene(i);
        scenes.forEach(function (s) { s.classList.toggle('is-active', s.dataset.acwSlide === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.acwThumb === String(i)); });
        if (scenes.length > 1) loadScene((parseInt(i, 10) + 1) % scenes.length);
      }
      var autoTimer = null;
      var currentSlide = 0;
      function showSlideTracked(i) { currentSlide = parseInt(i, 10) || 0; showSlide(i); }
      function startAuto() {
        if (scenes.length < 2 || autoTimer) return;
        autoTimer = setInterval(function () { showSlideTracked((currentSlide + 1) % scenes.length); }, 4200);
      }
      function stopAuto() { clearInterval(autoTimer); autoTimer = null; }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlideTracked(t.dataset.acwThumb); stopAuto(); startAuto(); }); });
      if (scenes.length > 1) setTimeout(function () { loadScene(1); }, 700);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        startAuto();
        document.addEventListener('visibilitychange', function () { if (document.hidden) stopAuto(); else startAuto(); });
        var gm = root.querySelector('[data-acw-gallery-main]');
        if (gm) { gm.addEventListener('mouseenter', stopAuto); gm.addEventListener('mouseleave', startAuto); gm.addEventListener('touchstart', function(){ stopAuto(); startAuto(); }, { passive: true }); }
      }
      function showSlideForModel(model) {
        if (!model) return;
        var target = null;
        scenes.forEach(function (s) {
          if (target === null && s.dataset.acwModel && model.indexOf(s.dataset.acwModel) !== -1) target = s.dataset.acwSlide;
        });
        if (target !== null) showSlide(target);
      }

      /* ---- quantity ---- */
      var qtyVal = root.querySelector('[data-acw-qty-val]');
      var qtyInput = root.querySelector('[data-acw-qty-input]');
      function setQty(n) {
        n = Math.max(1, Math.min(9, n));
        if (qtyVal) qtyVal.textContent = n;
        if (qtyInput) qtyInput.value = n;
      }
      var minus = root.querySelector('[data-acw-qty-minus]');
      var plus = root.querySelector('[data-acw-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) + 1); });

      /* ---- variant switching (by title; matches the model buttons) ---- */
      var formVariantId = root.querySelector('[data-acw-form-variant-id]');
      var priceEl = root.querySelector('[data-acw-price]');
      var compareEl = root.querySelector('[data-acw-compare]');
      var saveEl = root.querySelector('[data-acw-save]');
      var modelLabel = root.querySelector('[data-acw-model-label]');
      var addBtn = root.querySelector('[data-acw-add-btn]');
      var stickyPrice = root.querySelector('[data-acw-sticky-price]');
      var stickyModel = root.querySelector('[data-acw-sticky-model]');

      /* variant.price serialized via | json is in CENTS */
      function money(cents) { return '$' + (cents / 100).toFixed(2); }

      var selParts = (variants.length && formVariantId) ? (variants.find(function (v) { return String(v.id) === String(formVariantId.value); }) || variants[0]).title.split(' / ') : [];
      var selModel = selParts[0] || '';
      var selColor = selParts[1] || '';
      function applyVariant(title) {
        var match = variants.find(function (v) { return v.title === title; });
        if (!match) return;
        if (formVariantId) formVariantId.value = match.id;
        if (modelLabel) modelLabel.textContent = match.title;
        if (stickyModel) stickyModel.textContent = match.title;
        if (priceEl) {
          priceEl.textContent = money(match.price);
          priceEl.classList.add('is-pulsing');
          setTimeout(function () { priceEl.classList.remove('is-pulsing'); }, 260);
        }
        if (stickyPrice) stickyPrice.textContent = money(match.price);
        if (match.compareAtPrice && parseFloat(match.compareAtPrice) > parseFloat(match.price)) {
          if (compareEl) { compareEl.textContent = money(match.compareAtPrice); compareEl.hidden = false; }
          if (saveEl) {
            saveEl.textContent = 'SAVE ' + Math.round((match.compareAtPrice - match.price) / match.compareAtPrice * 100) + '%';
            saveEl.hidden = false;
          }
        } else {
          if (compareEl) compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
        if (addBtn) addBtn.disabled = !match.available;
        showSlideForModel(match.title);
      }
      function currentTitle() { return selColor ? (selModel + ' / ' + selColor) : selModel; }
      var colorLabel = root.querySelector('[data-acw-color-label]');
      root.querySelectorAll('[data-acw-model-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selModel = btn.dataset.acwModelBtn;
          root.querySelectorAll('[data-acw-model-btn]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyVariant(currentTitle());
        });
      });
      root.querySelectorAll('[data-acw-color-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selColor = btn.dataset.acwColorBtn;
          root.querySelectorAll('[data-acw-color-btn]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          if (colorLabel) colorLabel.textContent = selColor;
          applyVariant(currentTitle());
        });
      });

      /* ---- mobile sticky ATC: shows once buy box scrolls away ---- */
      var sticky = root.querySelector('[data-acw-sticky]');
      var buyBox = root.querySelector('[data-acw-buybox]');
      if (sticky && buyBox && 'IntersectionObserver' in window) {
        var sio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting); });
        }, { rootMargin: '-80px 0px 0px 0px' });
        sio.observe(buyBox);
      }
      var stickyAdd = root.querySelector('[data-acw-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', function () { if (addBtn) addBtn.click(); });

      /* ---- final CTA scrolls back to buy box ---- */
      var finalCta = root.querySelector('[data-acw-final-cta]');
      if (finalCta && buyBox) {
        finalCta.addEventListener('click', function (e) {
          e.preventDefault();
          buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ---- scroll progress bar ---- */
      var progress = root.querySelector('[data-acw-progress]');
      if (progress) {
        var onScrollProgress = function () {
          var h = document.documentElement;
          var max = h.scrollHeight - h.clientHeight;
          progress.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
        };
        window.addEventListener('scroll', onScrollProgress, { passive: true });
        onScrollProgress();
      }

      /* ---- delivery ETA: honest window = 24h dispatch + 5-9 day shipping ---- */
      var etaEl = root.querySelector('[data-acw-eta]');
      if (etaEl) {
        var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
        var a = new Date(); a.setDate(a.getDate() + 7);
        var b = new Date(); b.setDate(b.getDate() + 16);
        etaEl.textContent = fmt(a) + ' – ' + fmt(b);
      }

      /* ---- count-up stats ---- */
      var statsWrap = root.querySelector('[data-acw-stats]');
      if (statsWrap && 'IntersectionObserver' in window && !reduceMotion) {
        var counted = false;
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting || counted) return;
            counted = true;
            cio.unobserve(statsWrap);
            statsWrap.querySelectorAll('[data-acw-count]').forEach(function (el) {
              var target = parseFloat(el.dataset.acwCount);
              var decimals = parseInt(el.dataset.acwDecimal || '0', 10);
              var start = null;
              function tick(ts) {
                if (!start) start = ts;
                var p = Math.min((ts - start) / 1200, 1);
                var eased = 1 - Math.pow(1 - p, 3);
                el.textContent = (target * eased).toFixed(decimals);
                if (p < 1) requestAnimationFrame(tick);
              }
              requestAnimationFrame(tick);
            });
          });
        }, { threshold: 0.4 });
        cio.observe(statsWrap);
      } else if (statsWrap) {
        statsWrap.querySelectorAll('[data-acw-count]').forEach(function (el) {
          el.textContent = parseFloat(el.dataset.acwCount).toFixed(parseInt(el.dataset.acwDecimal || '0', 10));
        });
      }

      /* ---- subtle parallax on the hero gallery (desktop) ---- */
      var galleryMain = root.querySelector('[data-acw-gallery-main]');
      if (galleryMain && !reduceMotion && window.matchMedia('(min-width: 920px)').matches) {
        window.addEventListener('scroll', function () {
          var y = Math.min(window.scrollY, 600);
          galleryMain.style.setProperty('--acw-par', (y * 0.04) + 'px');
          if (!galleryMain.classList.contains('is-tilting')) {
            galleryMain.style.transform = 'translateY(' + (y * 0.04) + 'px)';
          }
        }, { passive: true });
      }

      /* ---- magnetic ATC (desktop micro-interaction) ---- */
      if (addBtn && !reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        addBtn.addEventListener('mousemove', function (e) {
          var r = addBtn.getBoundingClientRect();
          var dx = (e.clientX - r.left - r.width / 2) / r.width;
          var dy = (e.clientY - r.top - r.height / 2) / r.height;
          addBtn.style.transform = 'translate(' + (dx * 6).toFixed(1) + 'px,' + (dy * 4 - 2).toFixed(1) + 'px)';
        });
        addBtn.addEventListener('mouseleave', function () { addBtn.style.transform = ''; });
      }
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-diffuser-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.adf').forEach(function (root) {
      if (root.dataset.adfInit) return;
      root.dataset.adfInit = '1';

      var variants = JSON.parse(root.querySelector('[data-adf-variants]').textContent);
      var scenes = root.querySelectorAll('[data-adf-slide]');
      var thumbs = root.querySelectorAll('[data-adf-thumb]');

      /* ---- scroll reveal (bands fade up, grids inside them stagger child-by-child) ---- */
      var revealEls = document.querySelectorAll('.adf-reveal, .adf-stagger');
      if ('IntersectionObserver' in window && revealEls.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -10% 0px' });
        revealEls.forEach(function (el) { io.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('is-in'); });
      }

      /* ---- 3D tilt: hero product image tracks the cursor, cards get a
         lighter version of the same effect. Pointer devices only — touch
         just gets the flat card, no fake tilt from a tap. ---- */
      function attachTilt(el, opts) {
        if (!el || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        var maxTilt = (opts && opts.maxTilt) || 10;
        var scale = (opts && opts.scale) || 1.02;
        var activeClass = (opts && opts.activeClass) || 'is-tilting';
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          var rx = (0.5 - py) * maxTilt;
          var ry = (px - 0.5) * maxTilt;
          el.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(' + scale + ')';
          el.style.setProperty('--adf-glare-x', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--adf-glare-y', (py * 100).toFixed(1) + '%');
          el.classList.add(activeClass);
        });
        el.addEventListener('mouseleave', function () {
          el.style.transform = '';
          el.classList.remove(activeClass);
        });
      }
      attachTilt(root.querySelector('[data-adf-gallery-main]'), { maxTilt: 8, scale: 1.015 });
      root.querySelectorAll('[data-adf-tilt-card]').forEach(function (card) {
        attachTilt(card, { maxTilt: 6, scale: 1.015 });
      });

      /* ---- gallery ---- */
      function loadScene(i) {
        var scene = root.querySelector('[data-adf-slide="' + i + '"]');
        var img = scene && scene.querySelector('img[data-adf-src]');
        if (!img) return;
        img.src = img.dataset.adfSrc;
        delete img.dataset.adfSrc;
      }
      function showSlide(i) {
        loadScene(i);
        scenes.forEach(function (s) { s.classList.toggle('is-active', s.dataset.adfSlide === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.adfThumb === String(i)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.dataset.adfThumb); }); });
      function showSlideForImageUrl(url) {
        if (!url) return;
        var target = null;
        scenes.forEach(function (s) {
          var img = s.querySelector('img');
          if (img && (img.src === url || img.dataset.adfSrc === url)) target = s.dataset.adfSlide;
        });
        if (target !== null) showSlide(target);
      }

      /* ---- quantity ---- */
      var qtyVal = root.querySelector('[data-adf-qty-val]');
      var qtyInput = root.querySelector('[data-adf-qty-input]');
      function setQty(n) {
        n = Math.max(1, Math.min(99, n));
        if (qtyVal) qtyVal.textContent = n;
        if (qtyInput) qtyInput.value = n;
      }
      var minus = root.querySelector('[data-adf-qty-minus]');
      var plus = root.querySelector('[data-adf-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) + 1); });

      /* ---- color + kit -> variant ---- */
      var selectedColor = root.querySelector('.adf-swatch.is-active');
      selectedColor = selectedColor ? selectedColor.dataset.adfSwatch : variants[0].title.split(' / ')[0];
      var selectedKit = root.querySelector('.adf-pill.is-active');
      selectedKit = selectedKit ? selectedKit.dataset.adfKit : variants[0].title.split(' / ')[1];

      var formVariantId = root.querySelector('[data-adf-form-variant-id]');
      var priceEl = root.querySelector('[data-adf-price]');
      var compareEl = root.querySelector('[data-adf-compare]');
      var saveEl = root.querySelector('[data-adf-save]');
      var perUnitEl = root.querySelector('[data-adf-perunit]');
      var colorLabel = root.querySelector('[data-adf-color-label]');
      var addBtn = root.querySelector('[data-adf-add-btn]');

      function money(cents) { return '$' + (cents / 100).toFixed(2); }
      function kitStickCount(kitLabel) { return kitLabel && kitLabel.indexOf('6') === 0 ? 6 : 3; }

      /* ---- scent builder ---- */
      var scentNames = ['Cold Mountain', 'Vanilla Sky', 'La La Orange'];
      var scentQty = { 'Cold Mountain': 1, 'Vanilla Sky': 1, 'La La Orange': 1 };
      var scentMixInput = root.querySelector('[data-adf-scent-mix-input]');
      var builderCount = root.querySelector('[data-adf-builder-count]');
      var scentErr = root.querySelector('[data-adf-scent-error]');

      function scentTotal() { return scentNames.reduce(function (sum, n) { return sum + scentQty[n]; }, 0); }
      function renderScents() {
        scentNames.forEach(function (n) {
          var el = root.querySelector('[data-adf-scent-val="' + n + '"]');
          if (el) el.textContent = scentQty[n];
        });
        var total = scentTotal();
        var target = kitStickCount(selectedKit);
        if (builderCount) {
          builderCount.textContent = total + ' / ' + target + ' sticks';
          builderCount.classList.toggle('is-complete', total === target);
          builderCount.classList.toggle('is-over', total > target);
        }
        var mix = scentNames.filter(function (n) { return scentQty[n] > 0; })
          .map(function (n) { return scentQty[n] + 'x ' + n; }).join(', ');
        if (scentMixInput) scentMixInput.value = mix;
        var ok = total === target;
        if (addBtn) addBtn.disabled = !ok || addBtn.dataset.unavailable === '1';
        if (scentErr) {
          if (!ok && total !== 0) {
            scentErr.textContent = total > target
              ? 'Remove ' + (total - target) + ' stick' + ((total - target) > 1 ? 's' : '') + ' to match your kit size.'
              : 'Add ' + (target - total) + ' more stick' + ((target - total) > 1 ? 's' : '') + ' to fill your kit.';
            scentErr.classList.remove('hidden');
          } else {
            scentErr.classList.add('hidden');
          }
        }
      }
      root.querySelectorAll('[data-adf-scent-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = btn.dataset.adfScentPlus;
          if (scentTotal() < kitStickCount(selectedKit)) { scentQty[n]++; renderScents(); }
        });
      });
      root.querySelectorAll('[data-adf-scent-minus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = btn.dataset.adfScentMinus;
          if (scentQty[n] > 0) { scentQty[n]--; renderScents(); }
        });
      });
      var quickEven = root.querySelector('[data-adf-quick-even]');
      if (quickEven) quickEven.addEventListener('click', function () {
        var target = kitStickCount(selectedKit);
        var each = Math.floor(target / 3), rem = target - (each * 3);
        scentNames.forEach(function (n, idx) { scentQty[n] = each + (idx < rem ? 1 : 0); });
        renderScents();
      });
      root.querySelectorAll('[data-adf-quick-fav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var fav = btn.dataset.adfQuickFav;
          var target = kitStickCount(selectedKit);
          scentNames.forEach(function (n) { scentQty[n] = n === fav ? target : 0; });
          renderScents();
        });
      });

      function applyVariant() {
        var match = variants.find(function (v) {
          var parts = v.title.split(' / ');
          return parts[0] === selectedColor && parts[1] === selectedKit;
        });
        if (!match) return;
        if (formVariantId) formVariantId.value = match.id;
        if (colorLabel) colorLabel.textContent = selectedColor;
        if (priceEl) {
          priceEl.textContent = money(match.price);
          priceEl.classList.add('is-pulsing');
          setTimeout(function () { priceEl.classList.remove('is-pulsing'); }, 250);
        }
        if (match.compareAtPrice && parseFloat(match.compareAtPrice) > parseFloat(match.price)) {
          if (compareEl) { compareEl.textContent = money(match.compareAtPrice); compareEl.hidden = false; }
          if (saveEl) {
            var pct = Math.round((match.compareAtPrice - match.price) / match.compareAtPrice * 100);
            saveEl.textContent = 'Save ' + pct + '%';
            saveEl.hidden = false;
          }
        } else {
          if (compareEl) compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
        if (perUnitEl) {
          var sticks = kitStickCount(selectedKit);
          perUnitEl.textContent = money(match.price / sticks) + ' per stick';
        }
        addBtn.dataset.unavailable = match.available ? '0' : '1';
        showSlideForImageUrl(match.image);
        renderScents();
      }

      root.querySelectorAll('[data-adf-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedColor = btn.dataset.adfSwatch;
          root.querySelectorAll('[data-adf-swatch]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyVariant();
        });
      });
      root.querySelectorAll('[data-adf-kit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedKit = btn.dataset.adfKit;
          root.querySelectorAll('[data-adf-kit]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyVariant();
        });
      });

      applyVariant();
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-escape-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.esc');
  if (!root) return;
  root.classList.add('esc-js');

  /* reveal on scroll */
  var rs = root.querySelectorAll('.esc-r');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rs.forEach(function (el) { io.observe(el); });
  } else { rs.forEach(function (el) { el.classList.add('is-in'); }); }

  /* gallery: scroll-snap track + thumbs + arrows + counter */
  var track = root.querySelector('[data-esc-track]');
  var slides = track ? [].slice.call(track.querySelectorAll('[data-esc-slide]')) : [];
  var thumbs = [].slice.call(root.querySelectorAll('[data-esc-thumb]'));
  var countEl = root.querySelector('[data-esc-count]');
  var cur = 0;
  function goTo(i, smooth) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
  }
  function loadSlide(i) {
    var sl = slides[i]; if (!sl) return;
    var im = sl.querySelector('img[data-src]'); if (!im) return;
    im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
  }
  function setActive(i) {
    cur = i;
    loadSlide(i); loadSlide(i + 1); loadSlide(i - 1);
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    if (countEl) countEl.textContent = i + 1;
    var t = thumbs[i]; if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { loadSlide(k); goTo(k); }); });
  loadSlide(1);
  var prev = root.querySelector('[data-esc-prev]'), next = root.querySelector('[data-esc-next]');
  if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
  if (next) next.addEventListener('click', function () { goTo(cur + 1); });
  if (track) {
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== cur && slides[i]) setActive(i);
      });
    }, { passive: true });
  }

  /* qty */
  var qv = root.querySelector('[data-esc-qty-val]'), qi = root.querySelector('[data-esc-qty-input]');
  var packs = root.querySelector('[data-esc-packs]');
  var unit = packs ? parseInt(packs.dataset.unit, 10) : 0, wasUnit = packs ? parseInt(packs.dataset.was, 10) || 0 : 0;
  var fmt = function (c) { return (c / 100).toFixed(2); };
  try {
    var nf = new Intl.NumberFormat((packs && packs.dataset.locale) || undefined, { style: 'currency', currency: (packs && packs.dataset.currency) || 'USD' });
    fmt = function (c) { return nf.format(c / 100); };
  } catch (e) {}
  function pct(n) { return n >= 4 ? 0.30 : (n >= 2 ? 0.15 : 0); }
  function total(n) { return n * (unit - Math.floor(unit * pct(n) + 1e-9)); }
  function paint(n) {
    if (!packs || !unit) return;
    var now = root.querySelector('[data-esc-price]'), was = root.querySelector('[data-esc-was]'), save = root.querySelector('[data-esc-save]'), st = root.querySelector('[data-esc-sticky-price]');
    var t = total(n), w = (wasUnit > unit ? wasUnit : unit) * n;
    if (now) now.textContent = fmt(t);
    if (st) st.textContent = fmt(t);
    if (was) was.textContent = fmt(w);
    if (save) save.textContent = 'Save ' + fmt(w - t);
    packs.querySelectorAll('[data-esc-pack]').forEach(function (b) {
      var on = parseInt(b.dataset.escPack, 10) === n;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  if (packs && unit) {
    packs.querySelectorAll('[data-esc-pack]').forEach(function (b) {
      var n = parseInt(b.dataset.escPack, 10), el = b.querySelector('[data-esc-pack-price]');
      if (el) el.textContent = fmt(total(n));
      b.addEventListener('click', function () { setQty(n); });
    });
  }
  function setQty(n) { n = Math.max(1, Math.min(10, n)); if (qv) qv.textContent = n; if (qi) qi.value = n; paint(n); }
  var mi = root.querySelector('[data-esc-qty-minus]'), pl = root.querySelector('[data-esc-qty-plus]');
  if (mi) mi.addEventListener('click', function () { setQty(parseInt(qv.textContent, 10) - 1); });
  if (pl) pl.addEventListener('click', function () { setQty(parseInt(qv.textContent, 10) + 1); });

  /* add feedback + proxies */
  var add = root.querySelector('[data-esc-add]');
  if (add) add.addEventListener('click', function () { setTimeout(function () { add.classList.add('is-added'); setTimeout(function () { add.classList.remove('is-added'); }, 1800); }, 250); });
  var sAdd = root.querySelector('[data-esc-sticky-add]'), fAdd = root.querySelector('[data-esc-final-add]');
  if (sAdd && add) sAdd.addEventListener('click', function () { add.click(); });
  if (fAdd && add) fAdd.addEventListener('click', function () { add.click(); });

  /* sticky */
  var sticky = root.querySelector('[data-esc-sticky]'), buy = root.querySelector('.esc-buy');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }, { rootMargin: '-80px 0px 0px 0px' }).observe(buy);
  }

  /* tabs + step cycling */
  var tabs = root.querySelectorAll('[data-esc-tab]'), panels = root.querySelectorAll('[data-esc-panel]');
  var timer = null;
  function cycle(panel) {
    if (timer) clearInterval(timer);
    var steps = panel.querySelectorAll('.esc-step'); if (!steps.length) return;
    var i = 0;
    steps.forEach(function (s, k) { s.classList.toggle('is-live', k === 0); });
    timer = setInterval(function () { i = (i + 1) % steps.length; steps.forEach(function (s, k) { s.classList.toggle('is-live', k === i); }); }, 2600);
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      panels.forEach(function (p) { var on = p.dataset.escPanel === t.dataset.escTab; p.classList.toggle('is-active', on); if (on) cycle(p); });
    });
  });
  var first = root.querySelector('[data-esc-panel].is-active');
  if (first && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) cycle(first);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-fridge-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-fz]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  roots.forEach(function (root) {
    if (root.dataset.fzInit) return; root.dataset.fzInit = '1';
    if (!reduce) root.setAttribute('data-fz-ready', '1');

    /* reveal */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.18 });
    root.querySelectorAll('.fz-reveal').forEach(function (el) { io.observe(el); });

    /* dial */
    var dial = root.querySelector('[data-fz-dial]');
    if (dial) {
      var arc = dial.querySelector('[data-fz-arc]'), tempEl = dial.querySelector('[data-fz-temp]'), labelEl = dial.querySelector('[data-fz-mode-label]');
      var ticks = dial.querySelector('[data-fz-ticks]');
      for (var i = 0; i <= 30; i++) { var a = (i / 30) * 270 - 135, r = a * Math.PI / 180; var l = document.createElementNS('http://www.w3.org/2000/svg', 'line'); var x1 = 160 + Math.sin(r) * 112, y1 = 160 - Math.cos(r) * 112, x2 = 160 + Math.sin(r) * (i % 5 ? 118 : 124), y2 = 160 - Math.cos(r) * (i % 5 ? 118 : 124); l.setAttribute('x1', x1); l.setAttribute('y1', y1); l.setAttribute('x2', x2); l.setAttribute('y2', y2); ticks.appendChild(l); }
      var current = 24, raf;
      function setArc(t) { var frac = (24 - t) / 30; frac = Math.max(0, Math.min(1, frac)); arc.style.strokeDashoffset = 622 - 622 * 0.75 * frac; }
      function animateTo(target, label) {
        cancelAnimationFrame(raf); var start = current, t0 = performance.now(), dur = reduce ? 0 : 1600;
        function step(now) { var k = dur ? Math.min(1, (now - t0) / dur) : 1; var e = 1 - Math.pow(1 - k, 3); var val = start + (target - start) * e; current = val; tempEl.textContent = Math.round(val); setArc(val); if (k < 1) raf = requestAnimationFrame(step); else { current = target; dial.classList.toggle('is-cold', target <= 4); } }
        raf = requestAnimationFrame(step); if (label) labelEl.textContent = label;
      }
      var dialIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { animateTo(-6, 'LO mode · reached in minutes'); dialIO.disconnect(); } }); }, { threshold: 0.5 });
      dialIO.observe(dial);
      root.querySelectorAll('[data-fz-mode]').forEach(function (b) {
        b.addEventListener('click', function () { root.querySelectorAll('[data-fz-mode]').forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active'); animateTo(parseFloat(b.dataset.temp), b.dataset.label + ' · holds at ' + b.dataset.temp + ' °C'); });
      });
    }

    /* before/after slider */
    var ba = root.querySelector('[data-fz-ba]');
    if (ba) {
      var before = ba.querySelector('[data-fz-ba-before]'), handle = ba.querySelector('[data-fz-ba-handle]'), range = ba.querySelector('[data-fz-ba-range]'), frame = ba.querySelector('.fz-ba__frame');
      function setBA(pct) { pct = Math.max(2, Math.min(98, pct)); before.style.width = pct + '%'; before.style.setProperty('--fz-ba-w', pct / 100); handle.style.left = pct + '%'; range.value = pct; }
      range.addEventListener('input', function () { setBA(parseFloat(range.value)); });
      var drag = false;
      function fromEvent(e) { var r = frame.getBoundingClientRect(); var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left; setBA(x / r.width * 100); }
      frame.addEventListener('pointerdown', function (e) { drag = true; fromEvent(e); });
      window.addEventListener('pointermove', function (e) { if (drag) fromEvent(e); });
      window.addEventListener('pointerup', function () { drag = false; });
      setBA(55);
      if (!reduce) { var baIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; baIO.disconnect(); var t0 = performance.now(); (function step(now) { var k = Math.min(1, (now - t0) / 1800); var v = 55 + Math.sin(k * Math.PI * 2) * 22; setBA(v); if (k < 1) requestAnimationFrame(step); else setBA(55); })(t0); }); }, { threshold: 0.6 }); baIO.observe(ba); }
    }

    /* reviews slider */
    var rt = root.querySelector('[data-fz-revtrack]');
    if (rt) {
      root.querySelectorAll('[data-fz-rev]').forEach(function (b) { b.addEventListener('click', function () { rt.scrollBy({ left: parseInt(b.dataset.fzRev, 10) * (rt.firstElementChild.offsetWidth + 14), behavior: 'smooth' }); }); });
      if (!reduce) { var rtimer = setInterval(function () { if (rt.matches(':hover')) return; var max = rt.scrollWidth - rt.clientWidth; if (rt.scrollLeft >= max - 4) rt.scrollTo({ left: 0, behavior: 'smooth' }); else rt.scrollBy({ left: rt.firstElementChild.offsetWidth + 14, behavior: 'smooth' }); }, 4200); }
    }

    /* counters */
    var cIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; var el = e.target, target = parseFloat(el.dataset.fzCount), t0 = performance.now(), dur = reduce ? 0 : 1400; (function step(now) { var k = dur ? Math.min(1, (now - t0) / dur) : 1; el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); })(t0); cIO.unobserve(el); }); }, { threshold: 0.6 });
    root.querySelectorAll('[data-fz-count]').forEach(function (el) { cIO.observe(el); });

    /* battery */
    var batt = root.querySelector('[data-fz-batt]');
    if (batt) {
      var fillEl = batt.querySelector('[data-fz-batt-fill]'), vEl = batt.querySelector('[data-fz-batt-v]'), stEl = batt.querySelector('[data-fz-batt-state]');
      var bIO = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) return; bIO.disconnect();
        var t0 = performance.now(), dur = reduce ? 0 : 3500;
        (function step(now) { var k = dur ? Math.min(1, (now - t0) / dur) : 1; var w = 92 - 58 * k; fillEl.style.width = w + '%'; vEl.textContent = (12.8 - 1.2 * k).toFixed(1); if (k < 1) requestAnimationFrame(step); else { fillEl.classList.add('is-low'); fillEl.style.width = '34%'; stEl.textContent = 'Fridge stopped · 12 V protected'; setTimeout(function(){ fillEl.classList.remove('is-low'); }, 1200); } })(t0);
      }); }, { threshold: 0.5 });
      bIO.observe(batt);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-halloween-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hw').forEach(function (root) {
      if (root.dataset.hwInit) return;
      root.dataset.hwInit = '1';
      if ('IntersectionObserver' in window) root.classList.add('hw-js');

      var vEl = root.querySelector('[data-hw-variants]');
      var variants = vEl ? JSON.parse(vEl.textContent) : [];

      /* reveal */
      var rev = root.querySelectorAll('.hw-reveal');
      if ('IntersectionObserver' in window && rev.length) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px' });
        rev.forEach(function (el) { io.observe(el); });
      } else { rev.forEach(function (el) { el.classList.add('is-in'); }); }

      /* gallery */
      var scenes = root.querySelectorAll('[data-hw-slide]');
      var thumbs = root.querySelectorAll('[data-hw-thumb]');
      function loadScene(i) {
        var s = root.querySelector('[data-hw-slide="' + i + '"]');
        var img = s && s.querySelector('img[data-hw-src]');
        if (!img) return;
        img.src = img.dataset.hwSrc; delete img.dataset.hwSrc;
      }
      function show(i) {
        loadScene(i);
        scenes.forEach(function (s) { s.classList.toggle('is-active', s.dataset.hwSlide === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.hwThumb === String(i)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.hwThumb); }); });

      /* money */
      var moneyFmt = root.dataset.hwMoney || '${{amount}}';
      function money(cents) {
        var n = (cents / 100).toFixed(2);
        return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, n)
                       .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                       .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
                       .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
      }

      /* size selection */
      var priceEl = root.querySelector('[data-hw-price]');
      var compareEl = root.querySelector('[data-hw-compare]');
      var saveEl = root.querySelector('[data-hw-save]');
      var idInput = root.querySelector('[data-hw-form-variant-id]');
      var addBtn = root.querySelector('[data-hw-add-btn]');
      var sPrice = root.querySelector('[data-hw-sticky-price]');
      var sSize = root.querySelector('[data-hw-sticky-size]');

      function selectVariant(id) {
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (sPrice) sPrice.textContent = money(v.price);
        if (sSize) sSize.textContent = v.title + ' · set of 4';
        if (compareEl) {
          if (v.compare && v.compare > v.price) {
            compareEl.style.display = ''; compareEl.textContent = money(v.compare);
            if (saveEl) { saveEl.style.display = ''; saveEl.textContent = 'SAVE ' + money(v.compare - v.price).replace(/\.00$/, ''); }
          } else {
            compareEl.style.display = 'none';
            if (saveEl) saveEl.style.display = 'none';
          }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          var d = addBtn.querySelector('.hw-btn-add__default');
          if (d) d.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
        root.querySelectorAll('[data-hw-size-btn]').forEach(function (b) {
          b.classList.toggle('is-active', String(b.dataset.hwSizeBtn) === String(id));
        });
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (e) {}
      }
      root.querySelectorAll('[data-hw-size-btn]').forEach(function (b) {
        b.addEventListener('click', function () { selectVariant(b.dataset.hwSizeBtn); });
      });

      /* qty */
      var qtyVal = root.querySelector('[data-hw-qty-val]');
      var qtyInput = root.querySelector('[data-hw-qty-input]');
      function setQty(n) {
        n = Math.max(1, Math.min(10, n));
        if (qtyVal) qtyVal.textContent = n;
        if (qtyInput) qtyInput.value = n;
      }
      var minus = root.querySelector('[data-hw-qty-minus]');
      var plus = root.querySelector('[data-hw-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) + 1); });

      /* added feedback */
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          setTimeout(function () {
            addBtn.classList.add('is-added');
            setTimeout(function () { addBtn.classList.remove('is-added'); }, 1800);
          }, 250);
        });
      }

      /* discount code copy */
      root.querySelectorAll('[data-hw-copy-code]').forEach(function (b) {
        b.addEventListener('click', function () {
          var code = b.dataset.hwCopyCode;
          var lbl = b.querySelector('[data-hw-copy-label]');
          function done() { b.classList.add('is-copied'); if (lbl) lbl.textContent = 'Copied'; setTimeout(function(){ b.classList.remove('is-copied'); if (lbl) lbl.textContent = 'Copy'; }, 1800); }
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
        });
      });

      /* sticky */
      var sticky = root.querySelector('[data-hw-sticky]');
      var buyBox = root.querySelector('.hw-buy');
      if (sticky && buyBox && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          sticky.classList.toggle('is-on', !es[0].isIntersecting);
        }, { rootMargin: '-120px 0px 0px 0px' }).observe(buyBox);
      }
      var sAdd = root.querySelector('[data-hw-sticky-add]');
      if (sAdd && addBtn) sAdd.addEventListener('click', function () { addBtn.click(); });

      /* size help scroll */
      var sizeHelp = root.querySelector('[data-hw-scroll-size]');
      if (sizeHelp) sizeHelp.addEventListener('click', function () {
        var faq = root.querySelector('#hw-faq');
        if (faq) {
          faq.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var d = faq.querySelectorAll('details')[1];
          if (d) d.open = true;
        }
      });

      /* countdown to 31 Oct */
      var target = new Date(new Date().getFullYear(), 9, 31, 23, 59, 59);
      if (target < new Date()) target = new Date(new Date().getFullYear() + 1, 9, 31, 23, 59, 59);
      function tick() {
        var ms = target - new Date();
        if (ms < 0) ms = 0;
        var d = Math.floor(ms / 86400000);
        var h = Math.floor(ms % 86400000 / 3600000);
        var m = Math.floor(ms % 3600000 / 60000);
        var set = function (sel, val) { var e = root.querySelector(sel); if (e) e.textContent = val; };
        set('[data-hw-c-d]', d); set('[data-hw-c-h]', h); set('[data-hw-c-m]', m);
        var dayEl = root.querySelector('[data-hw-days]');
        if (dayEl) dayEl.textContent = d + (d === 1 ? ' day to go.' : ' days to go.');
      }
      tick();
      setInterval(tick, 30000);
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-keycard-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.akc').forEach(function (root) {
      if (root.dataset.akcInit) return;
      root.dataset.akcInit = '1';

      var variants = JSON.parse(root.querySelector('[data-akc-variants]').textContent);

      /* ---- gallery: same deferred-load pattern as the AutoShade PDP ---- */
      var scenes = root.querySelectorAll('[data-akc-slide]');
      var thumbs = root.querySelectorAll('[data-akc-thumb]');
      function loadScene(i) {
        var scene = root.querySelector('[data-akc-slide="' + i + '"]');
        var img = scene && scene.querySelector('img[data-akc-src]');
        if (!img) return;
        img.src = img.dataset.akcSrc;
        delete img.dataset.akcSrc;
      }
      function showSlide(i) {
        loadScene(i);
        scenes.forEach(function (s) { s.classList.toggle('is-active', s.dataset.akcSlide === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.akcThumb === String(i)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.dataset.akcThumb); }); });

      function showSlideForImageUrl(url) {
        if (!url) return;
        var target = null;
        scenes.forEach(function (s) {
          var img = s.querySelector('img');
          if (img && (img.src === url || img.dataset.akcSrc === url)) target = s.dataset.akcSlide;
        });
        if (target !== null) showSlide(target);
      }

      /* ---- quantity ---- */
      var qtyVal = root.querySelector('[data-akc-qty-val]');
      var qtyInput = root.querySelector('[data-akc-qty-input]');
      function setQty(n) {
        n = Math.max(1, Math.min(99, n));
        if (qtyVal) qtyVal.textContent = n;
        if (qtyInput) qtyInput.value = n;
        var stickyPrice = root.querySelector('[data-akc-sticky-price]');
      }
      var minus = root.querySelector('[data-akc-qty-minus]');
      var plus = root.querySelector('[data-akc-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) + 1); });

      /* ---- color + style -> resolve matching variant ---- */
      var selectedColor = root.querySelector('.akc-swatch.is-active');
      selectedColor = selectedColor ? selectedColor.dataset.akcSwatch : (variants[0].title.split(' / ')[0]);
      var selectedStyle = root.querySelector('.akc-pill.is-active');
      selectedStyle = selectedStyle ? selectedStyle.dataset.akcStyle : (variants[0].title.split(' / ')[1]);

      var formVariantId = root.querySelector('[data-akc-form-variant-id]');
      var priceEl = root.querySelector('[data-akc-price]');
      var compareEl = root.querySelector('[data-akc-compare]');
      var saveEl = root.querySelector('[data-akc-save]');
      var colorLabel = root.querySelector('[data-akc-color-label]');
      var addBtn = root.querySelector('[data-akc-add-btn]');
      var stickyPriceEl = root.querySelector('[data-akc-sticky-price]');

      function money(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function applyVariant() {
        var match = variants.find(function (v) {
          var parts = v.title.split(' / ');
          return parts[0] === selectedColor && parts[1] === selectedStyle;
        });
        if (!match) return;
        if (formVariantId) formVariantId.value = match.id;
        if (colorLabel) colorLabel.textContent = selectedColor;
        if (priceEl) priceEl.textContent = money(match.price);
        if (stickyPriceEl) stickyPriceEl.textContent = money(match.price);
        if (match.compareAtPrice && parseFloat(match.compareAtPrice) > parseFloat(match.price)) {
          if (compareEl) { compareEl.textContent = money(match.compareAtPrice); compareEl.hidden = false; }
          if (saveEl) {
            var pct = Math.round((match.compareAtPrice - match.price) / match.compareAtPrice * 100);
            saveEl.textContent = 'Save ' + pct + '%';
            saveEl.hidden = false;
          }
        } else {
          if (compareEl) compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
        if (addBtn) addBtn.disabled = !match.available;
        showSlideForImageUrl(match.image);
      }

      root.querySelectorAll('[data-akc-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedColor = btn.dataset.akcSwatch;
          root.querySelectorAll('[data-akc-swatch]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyVariant();
        });
      });
      root.querySelectorAll('[data-akc-style]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedStyle = btn.dataset.akcStyle;
          root.querySelectorAll('[data-akc-style]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyVariant();
        });
      });

      /* ---- mobile sticky CTA: appears once the real buy box scrolls out of view ---- */
      var sticky = document.querySelector('[data-akc-sticky]');
      var buyBox = root.querySelector('.akc-buy');
      if (sticky && buyBox && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting); });
        }, { rootMargin: '-90px 0px 0px 0px' });
        io.observe(buyBox);
      }
      var stickyAdd = document.querySelector('[data-akc-sticky-add]');
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          var realBtn = root.querySelector('[data-akc-add-btn]');
          if (realBtn) realBtn.click();
        });
      }
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-nfcmetal-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.anm').forEach(function (root) {
      if (root.dataset.anmInit) return;
      root.dataset.anmInit = '1';

      var variants = JSON.parse(root.querySelector('[data-anm-variants]').textContent);

      /* ---- scroll reveal ---- */
      var revealEls = document.querySelectorAll('.anm-reveal, .anm-stagger');
      if ('IntersectionObserver' in window && revealEls.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -10% 0px' });
        revealEls.forEach(function (el) { io.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('is-in'); });
      }

      /* ---- 3D tilt ---- */
      function attachTilt(el, opts) {
        if (!el || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        var maxTilt = (opts && opts.maxTilt) || 10;
        var scale = (opts && opts.scale) || 1.02;
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          var rx = (0.5 - py) * maxTilt;
          var ry = (px - 0.5) * maxTilt;
          el.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(' + scale + ')';
          el.style.setProperty('--anm-glare-x', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--anm-glare-y', (py * 100).toFixed(1) + '%');
          el.classList.add('is-tilting');
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; el.classList.remove('is-tilting'); });
      }
      attachTilt(root.querySelector('[data-anm-gallery-main]'), { maxTilt: 8, scale: 1.015 });
      root.querySelectorAll('[data-anm-tilt-card]').forEach(function (card) { attachTilt(card, { maxTilt: 7, scale: 1.03 }); });

      /* ---- gallery ---- */
      var scenes = root.querySelectorAll('[data-anm-slide]');
      var thumbs = root.querySelectorAll('[data-anm-thumb]');
      function loadScene(i) {
        var scene = root.querySelector('[data-anm-slide="' + i + '"]');
        var img = scene && scene.querySelector('img[data-anm-src]');
        if (!img) return;
        img.src = img.dataset.anmSrc;
        delete img.dataset.anmSrc;
      }
      function showSlide(i) {
        loadScene(i);
        scenes.forEach(function (s) { s.classList.toggle('is-active', s.dataset.anmSlide === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.anmThumb === String(i)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.dataset.anmThumb); }); });
      function showSlideForColor(color) {
        if (!color) return;
        var scene = root.querySelector('[data-anm-color="' + CSS.escape(color) + '"]');
        if (scene) showSlide(scene.dataset.anmSlide);
      }

      var qtyVal = root.querySelector('[data-anm-qty-val]');
      var qtyInput = root.querySelector('[data-anm-qty-input]');
      function setQty(n) {
        n = Math.max(1, Math.min(99, n));
        if (qtyVal) qtyVal.textContent = n;
        if (qtyInput) qtyInput.value = n;
      }
      var minus = root.querySelector('[data-anm-qty-minus]');
      var plus = root.querySelector('[data-anm-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) + 1); });

      var selectedColor = root.querySelector('.anm-swatch.is-active');
      selectedColor = selectedColor ? selectedColor.dataset.anmSwatch : variants[0].title;

      var formVariantId = root.querySelector('[data-anm-form-variant-id]');
      var priceEl = root.querySelector('[data-anm-price]');
      var compareEl = root.querySelector('[data-anm-compare]');
      var saveEl = root.querySelector('[data-anm-save]');
      var colorLabel = root.querySelector('[data-anm-color-label]');
      var addBtn = root.querySelector('[data-anm-add-btn]');

      function money(cents) { return '$' + (cents / 100).toFixed(2); }

      function applyVariant() {
        var match = variants.find(function (v) { return v.title === selectedColor; });
        if (!match) return;
        if (formVariantId) formVariantId.value = match.id;
        if (colorLabel) colorLabel.textContent = selectedColor;
        if (priceEl) {
          priceEl.textContent = money(match.price);
          priceEl.classList.add('is-pulsing');
          setTimeout(function () { priceEl.classList.remove('is-pulsing'); }, 250);
        }
        if (match.compareAtPrice && parseFloat(match.compareAtPrice) > parseFloat(match.price)) {
          if (compareEl) { compareEl.textContent = money(match.compareAtPrice); compareEl.hidden = false; }
          if (saveEl) {
            var pct = Math.round((match.compareAtPrice - match.price) / match.compareAtPrice * 100);
            saveEl.textContent = 'Save ' + pct + '%'; saveEl.hidden = false;
          }
        } else {
          if (compareEl) compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
        if (addBtn) addBtn.disabled = !match.available;
        showSlideForColor(selectedColor);
      }

      root.querySelectorAll('[data-anm-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedColor = btn.dataset.anmSwatch;
          root.querySelectorAll('[data-anm-swatch]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          applyVariant();
        });
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ax').forEach(function (root) {
    if (root.dataset.axInit) return;
    root.dataset.axInit = '1';

    /* ---- gallery ---- */
    var scenes = root.querySelectorAll('[data-ax-slide]');
    var thumbs = root.querySelectorAll('[data-ax-thumb]');
    var galleryIndex = 0;
    /* Each non-first scene ships with data-ax-src instead of src, so it never
       enters the browser's request queue until we ask for it here. Loading a
       scene warms it into the image cache; showing it (below) never blocks
       on network unless something calls showSlide before this had a chance. */
    /* posters of below-the-fold videos are fetched only when they come near the viewport */
    var lazyPosters = root.querySelectorAll('[data-ax-lazy-poster]');
    if (lazyPosters.length && 'IntersectionObserver' in window) {
      var pio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.poster = e.target.dataset.axLazyPoster; pio.unobserve(e.target); } }); }, { rootMargin: '400px 0px' });
      lazyPosters.forEach(function (v) { pio.observe(v); });
    } else { lazyPosters.forEach(function (v) { v.poster = v.dataset.axLazyPoster; }); }
    function loadScene(i) {
      var scene = root.querySelector('[data-ax-slide="' + i + '"]');
      var el = scene && scene.querySelector('[data-ax-src]');
      if (!el) return;
      if (el.dataset.axSrcset) { el.srcset = el.dataset.axSrcset; delete el.dataset.axSrcset; }
      if (el.dataset.axPoster) { el.poster = el.dataset.axPoster; delete el.dataset.axPoster; }
      el.src = el.dataset.axSrc;
      if (el.tagName === 'VIDEO') el.load();
      delete el.dataset.axSrc;
    }
    function showSlide(i) {
      galleryIndex = parseInt(i, 10) || 0;
      loadScene(galleryIndex);
      scenes.forEach(function (s) {
        var active = s.dataset.axSlide === String(i);
        s.classList.toggle('is-active', active);
        var vid = s.querySelector('video');
        if (vid) {
          if (active) { vid.play().catch(function () {}); } else { vid.pause(); vid.currentTime = 0; }
        }
      });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.axThumb === String(i)); });
      /* pre-warm the next slide while this one is on screen, so autoplay
         and manual thumb clicks never sit on a visible network stall */
      if (scenes.length > 1) loadScene((galleryIndex + 1) % scenes.length);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.dataset.axThumb); restartAutoplay(); });
      t.addEventListener('mouseenter', function () { loadScene(t.dataset.axThumb); });
    });
    /* warm slide 2 right after first paint, well ahead of the first
       autoplay tick, without competing with the hero image for bandwidth */
    if (scenes.length > 1) {
      setTimeout(function () { loadScene(1); }, 600);
    }

    /* ---- gallery autoplay ----
       Rotates on its own so buyers see every angle without clicking through
       thumbnails; pauses on hover (hover is already "zoom" intent) and while
       the tab is hidden, and restarts after a manual thumb click. */
    var autoplayTimer = null;
    function startAutoplay() {
      if (scenes.length < 2 || autoplayTimer) return;
      autoplayTimer = setInterval(function () {
        showSlide((galleryIndex + 1) % scenes.length);
      }, 3500);
    }
    function stopAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
    function restartAutoplay() { stopAutoplay(); startAutoplay(); }
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      startAutoplay();
      var galleryMain = root.querySelector('[data-ax-gallery-main]');
      if (galleryMain) {
        galleryMain.addEventListener('mouseenter', stopAutoplay);
        galleryMain.addEventListener('mouseleave', startAutoplay);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay(); else startAutoplay();
      });
    }

    /* ---- gallery zoom ----
       Pointer devices: origin follows the cursor so you zoom into what you're
       looking at. Touch: tap toggles a fixed 2.1x, since there's no hover. */
    var stage = root.querySelector('[data-ax-gallery-main]');
    if (stage) {
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--ax-zx', ((e.clientX - r.left) / r.width * 100) + '%');
        stage.style.setProperty('--ax-zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      stage.addEventListener('mouseleave', function () {
        stage.style.setProperty('--ax-zx', '50%');
        stage.style.setProperty('--ax-zy', '50%');
      });
      stage.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: hover)').matches) return;
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--ax-zx', ((e.clientX - r.left) / r.width * 100) + '%');
        stage.style.setProperty('--ax-zy', ((e.clientY - r.top) / r.height * 100) + '%');
        stage.classList.toggle('is-zoomed');
      });
    }

    /* ---- quantity ---- */
    var qtyVal = root.querySelector('[data-ax-qty-val]');
    var qtyInput = root.querySelector('[data-ax-qty-input]');
    function setQty(n) {
      n = Math.max(1, Math.min(99, n));
      if (qtyVal) qtyVal.textContent = n;
      if (qtyInput) qtyInput.value = n;
    }
    var minus = root.querySelector('[data-ax-qty-minus]');
    var plus = root.querySelector('[data-ax-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyVal.textContent, 10) + 1); });

    /* ---- variants ---- */
    var variantBtns = root.querySelectorAll('[data-ax-variant-id]');
    var formVariantId = root.querySelector('[data-ax-form-variant-id]');
    var priceEl = root.querySelector('[data-ax-price]');
    var compareEl = root.querySelector('[data-ax-compare]');
    var saveEl = root.querySelector('[data-ax-save]');
    var stockText = root.querySelector('[data-ax-stock-text]');
    var stockDot = root.querySelector('[data-ax-stock-dot]');
    var variantLabel = root.querySelector('[data-ax-variant-label]');
    var addBtn = root.querySelector('.ax-btn-add');
    var express = root.querySelector('[data-ax-express]');

    /* ---- required fitment field ----
       On a made-to-order product the buyer's model is not decoration: an order
       without it can't be cut. Three ways out of this page add to cart, so all
       three are gated from one place —
         1. the normal AJAX submit (FormData, carries properties by itself)
         2. the express-to-checkout submit further down (hand-built payload,
            so the property has to be attached explicitly)
         3. wallet / dynamic checkout buttons, which read the variant straight
            from Shopify and cannot carry a property at all — those stay hidden
            until the field is filled. */
    var fitment = root.querySelector('[data-ax-fitment]');
    var fitmentInput = root.querySelector('[data-ax-fitment-input]');
    var fitmentErr = root.querySelector('[data-ax-fitment-err]');
    var variantAvailable = addBtn ? !addBtn.disabled : true;

    function fitmentValue() {
      return fitmentInput ? fitmentInput.value.replace(/\s+/g, ' ').trim() : '';
    }

    /* two characters is not a car; three lets "BMW" through */
    function fitmentValid() {
      return !fitmentInput || fitmentValue().length >= 3;
    }

    function showFitmentError() {
      if (!fitment) return;
      fitment.classList.add('is-invalid');
      if (fitmentErr) fitmentErr.hidden = false;
    }

    function clearFitmentError() {
      if (!fitment) return;
      fitment.classList.remove('is-invalid');
      if (fitmentErr) fitmentErr.hidden = true;
    }

    function refreshBuyState() {
      if (addBtn) {
        addBtn.disabled = !variantAvailable;
        var def = addBtn.querySelector('.ax-btn-add__default');
        if (def) def.textContent = variantAvailable ? 'Add to Cart' : 'Sold Out';
      }
      if (express) express.hidden = !variantAvailable || !fitmentValid();
    }

    /* the placeholder does the teaching: once a model is chosen, the only thing
       still missing is the build year, so ask for exactly that */
    function syncFitmentHint(variantName) {
      if (!fitmentInput) return;
      var base = fitmentInput.dataset.axFitmentPlaceholder || '';
      var name = (variantName || '').trim();
      var isCustom = /^other\b|custom[- ]fit|not listed/i.test(name);
      fitmentInput.placeholder = name && !isCustom ? name + ' — build year' : base;
    }

    if (fitmentInput) {
      fitmentInput.addEventListener('input', function () {
        if (fitmentValid()) clearFitmentError();
        refreshBuyState();
      });
      fitmentInput.addEventListener('blur', function () {
        if (fitmentValue() !== '' && !fitmentValid()) showFitmentError();
      });
      /* fires when the browser's own required-check rejects a native submit */
      fitmentInput.addEventListener('invalid', showFitmentError);

      /* `required` + `minlength` already stop an empty or one-word entry at the
         browser level. This catches what they can't — whitespace that satisfies
         the attributes but isn't a car — and it has to listen on `window`:
         the theme delegates submit on `document` in the capture phase, and
         capture runs window before document, so anything bound lower down
         (the form, the component) would fire after the cart add had started. */
      var buyForm = fitmentInput.form;
      if (buyForm) {
        window.addEventListener(
          'submit',
          function (e) {
            if (e.target !== buyForm || fitmentValid()) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            showFitmentError();
            fitmentInput.focus({ preventScroll: true });
            fitmentInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          },
          true
        );
      }
      refreshBuyState();
    }

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = btn.dataset;
        variantBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (formVariantId) formVariantId.value = d.axVariantId;
        if (priceEl) priceEl.textContent = d.axVariantPrice;
        if (variantLabel) variantLabel.textContent = d.axVariantName;

        var showCompare = d.axVariantShowCompare === 'true';
        if (compareEl) { compareEl.textContent = d.axVariantCompare; compareEl.hidden = !showCompare; }
        if (saveEl) { saveEl.textContent = d.axVariantSave; saveEl.hidden = !showCompare; }

        var available = d.axVariantAvailable === 'true';
        variantAvailable = available;
        if (stockText) stockText.textContent = d.axVariantStock;
        if (stockDot) stockDot.classList.toggle('is-out', !available);
        refreshBuyState();
        syncFitmentHint(d.axVariantName);

        var match = null;
        if (d.axVariantMediaId) match = root.querySelector('[data-ax-media-id="' + d.axVariantMediaId + '"]');
        if (!match && d.axVariantImageId) match = root.querySelector('[data-ax-image-id="' + d.axVariantImageId + '"]');
        if (match) { showSlide(match.dataset.axSlide); if (typeof restartAutoplay === 'function') restartAutoplay(); }
      });
    });

    /* ---- added state ---- */
    var productForm = root.querySelector('product-form-component');
    if (productForm && addBtn) {
      productForm.addEventListener('submit', function () {
        addBtn.classList.add('is-added');
        setTimeout(function () { addBtn.classList.remove('is-added'); }, 2200);
      });
    }

    /* ---- scroll reveal ---- */
    var reveals = root.querySelectorAll('.ax-reveal');
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* ---- express checkout: skip the cart entirely ----
       Adds to cart via the AJAX API then sends the buyer straight to
       /checkout. Removes the cart-drawer step, which is where a lot of
       intent leaks away on mobile. */
    var expressForm = root.querySelector('[data-ax-express-checkout]');
    if (expressForm) {
      var form = expressForm.querySelector('form');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var btn = root.querySelector('.ax-btn-add');
          var def = btn && btn.querySelector('.ax-btn-add__default');
          var original = def ? def.textContent : '';
          if (btn) { btn.disabled = true; }
          if (def) { def.textContent = 'Taking you to checkout…'; }
          /* this payload is hand-built, so anything the buyer typed has to be
             copied across by name — otherwise a required field would collect
             nothing on the express path */
          var payload = {
            id: root.querySelector('[data-ax-form-variant-id]').value,
            quantity: parseInt(root.querySelector('[data-ax-qty-input]').value, 10) || 1
          };
          var props = {};
          form.querySelectorAll('[name^="properties["]').forEach(function (el) {
            var match = el.name.match(/^properties\[(.+)\]$/);
            if (!match) return;
            var val = (el.value || '').replace(/\s+/g, ' ').trim();
            if (val) props[match[1]] = val;
          });
          if (Object.keys(props).length) payload.properties = props;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            if (btn) { btn.disabled = false; }
            if (def) { def.textContent = original; }
            var err = root.querySelector('.ax-btn-add__error');
            if (err) { err.classList.remove('hidden'); err.textContent = "Couldn't reach checkout — please try again."; }
          });
        }, true);
      }
    }

    /* ---- copy the discount code ---- */
    var copyBtn = root.querySelector('[data-ax-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.dataset.axCopy;
        var state = copyBtn.querySelector('[data-ax-copy-state]');
        function ok() {
          copyBtn.classList.add('is-copied');
          if (state) state.textContent = 'Copied';
          setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            if (state) state.textContent = 'Copy';
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(ok).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = code; t.setAttribute('readonly', '');
          t.style.position = 'absolute'; t.style.left = '-9999px';
          document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); ok(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    }

    /* ---- review carousel ---- */
    var revcar = root.querySelector('[data-ax-revcar]');
    if (revcar) {
      var slides = revcar.querySelectorAll('[data-ax-rev]');
      var dots = revcar.querySelectorAll('[data-ax-rev-dot]');
      var cur = 0;
      function showRev(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === cur); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === cur); });
      }
      var prev = revcar.querySelector('[data-ax-rev-prev]');
      var next = revcar.querySelector('[data-ax-rev-next]');
      if (prev) prev.addEventListener('click', function () { showRev(cur - 1); });
      if (next) next.addEventListener('click', function () { showRev(cur + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { showRev(parseInt(d.dataset.axRevDot, 10)); });
      });
      /* swipe on touch */
      var sx = null;
      revcar.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      revcar.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 45) showRev(dx < 0 ? cur + 1 : cur - 1);
        sx = null;
      }, { passive: true });
    }

    /* ---- rating jumps to the reviews section ---- */
    var ratingLink = root.querySelector('[data-ax-scroll-reviews]');
    if (ratingLink) {
      ratingLink.addEventListener('click', function (e) {
        var target = root.querySelector('[id^="ax-reviews-"]');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* ---- final CTA scroll ---- */
    var topLink = root.querySelector('[data-ax-scroll-top]');
    if (topLink) {
      topLink.addEventListener('click', function (e) {
        e.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-pullshade-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.ps');
  if (!root) return;
  root.classList.add('ps-js');

  var rs = root.querySelectorAll('.ps-r');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rs.forEach(function (el) { io.observe(el); });
  } else { rs.forEach(function (el) { el.classList.add('is-in'); }); }

  var track = root.querySelector('[data-ps-track]');
  var slides = track ? [].slice.call(track.querySelectorAll('[data-ps-slide]')) : [];
  var thumbs = [].slice.call(root.querySelectorAll('[data-ps-thumb]'));
  var countEl = root.querySelector('[data-ps-count]');
  var cur = 0;
  function goTo(i, smooth) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
  }
  function loadSlide(i) {
    var sl = slides[i]; if (!sl) return;
    var im = sl.querySelector('img[data-src]'); if (!im) return;
    im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
  }
  function setActive(i) {
    cur = i;
    loadSlide(i); loadSlide(i + 1); loadSlide(i - 1);
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    if (countEl) countEl.textContent = i + 1;
    var t = thumbs[i]; if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { loadSlide(k); goTo(k); }); });
  loadSlide(1);
  var prev = root.querySelector('[data-ps-prev]'), next = root.querySelector('[data-ps-next]');
  if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
  if (next) next.addEventListener('click', function () { goTo(cur + 1); });
  if (track) {
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== cur && slides[i]) setActive(i);
      });
    }, { passive: true });
  }

  var qv = root.querySelector('[data-ps-qty-val]'), qi = root.querySelector('[data-ps-qty-input]');
  function setQty(n) { n = Math.max(1, Math.min(10, n)); if (qv) qv.textContent = n; if (qi) qi.value = n; }
  var mi = root.querySelector('[data-ps-qty-minus]'), pl = root.querySelector('[data-ps-qty-plus]');
  if (mi) mi.addEventListener('click', function () { setQty(parseInt(qv.textContent, 10) - 1); });
  if (pl) pl.addEventListener('click', function () { setQty(parseInt(qv.textContent, 10) + 1); });

  var add = root.querySelector('[data-ps-add]');
  if (add) add.addEventListener('click', function () { setTimeout(function () { add.classList.add('is-added'); setTimeout(function () { add.classList.remove('is-added'); }, 1800); }, 250); });
  var sAdd = root.querySelector('[data-ps-sticky-add]'), fAdd = root.querySelector('[data-ps-final-add]');
  if (sAdd && add) sAdd.addEventListener('click', function () { add.click(); });
  if (fAdd && add) fAdd.addEventListener('click', function () { add.click(); });

  var sticky = root.querySelector('[data-ps-sticky]'), buy = root.querySelector('.ps-buy');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { sticky.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }, { rootMargin: '-80px 0px 0px 0px' }).observe(buy);
  }

  /* video demo: one frame, two clips, synced steps */
  var demo = root.querySelector('[data-ps-demo]');
  if (demo) {
    var v = demo.querySelector('[data-ps-video]'), fr = demo.querySelector('[data-ps-frame]'), vt = demo.querySelector('[data-ps-vt]'), bar = demo.querySelector('[data-ps-bar]');
    var play = demo.querySelector('[data-ps-play]'), snd = demo.querySelector('[data-ps-snd]'), line = demo.querySelector('[data-ps-mute-line]');
    var small = window.matchMedia('(max-width: 767px)').matches, clip = '1';
    function src(c) { return small ? v.dataset['sd' + c] : v.dataset['hd' + c]; }
    function stepsFor(c) { return [].slice.call(demo.querySelectorAll('[data-ps-steps="' + c + '"] .ps-demo__step')); }
    function setClip(c, autoplay) {
      clip = c; v.pause(); v.setAttribute('poster', v.dataset['poster' + c] || ''); v.setAttribute('src', src(c)); v.load();
      demo.querySelectorAll('[data-ps-clip]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.psClip === c); });
      demo.querySelectorAll('[data-ps-steps]').forEach(function (g) { g.hidden = g.dataset.psSteps !== c; });
      if (vt) vt.textContent = '0.0 s'; if (bar) bar.style.width = '0%';
      if (autoplay) go();
    }
    function go() { if (!v.getAttribute('src')) v.setAttribute('src', src(clip)); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    if ('IntersectionObserver' in window && v.dataset.posterLazy) { new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { v.setAttribute('poster', v.dataset.posterLazy); o.disconnect(); } }, { rootMargin: '600px 0px' }).observe(fr); } else if (v.dataset.posterLazy) { v.setAttribute('poster', v.dataset.posterLazy); }
    v.addEventListener('play', function () { fr.classList.add('is-playing'); });
    v.addEventListener('pause', function () { fr.classList.remove('is-playing'); });
    v.addEventListener('timeupdate', function () {
      var t = v.currentTime; if (vt) vt.textContent = t.toFixed(1) + ' s'; if (bar && v.duration) bar.style.width = (t / v.duration * 100) + '%';
      var st = stepsFor(clip), cur = 0;
      st.forEach(function (el, i) { if (t >= parseFloat(el.dataset.from)) cur = i; });
      st.forEach(function (el, i) { el.classList.toggle('is-on', i === cur); el.classList.toggle('is-done', i < cur); });
    });
    if (play) play.addEventListener('click', go);
    v.addEventListener('click', function () { if (v.paused) go(); else v.pause(); });
    if (snd) snd.addEventListener('click', function () { v.muted = !v.muted; if (line) line.style.display = v.muted ? '' : 'none'; if (v.paused) go(); });
    demo.querySelectorAll('[data-ps-clip]').forEach(function (b) { b.addEventListener('click', function () { setClip(b.dataset.psClip, true); }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) go(); } else if (!v.paused) v.pause(); }); }, { threshold: [0, 0.5] }).observe(fr);
    }
  }

  var rvMore = root.querySelector('[data-ps-rv-more]'), rvWrap = root.querySelector('[data-ps-rv]');
  if (rvMore && rvWrap) rvMore.addEventListener('click', function () { rvWrap.classList.add('ps-rv--open'); rvMore.style.display = 'none'; });

  var stepsWrap = root.querySelector('[data-ps-steps]');
  if (stepsWrap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var steps = stepsWrap.querySelectorAll('.ps-step'), si = 0;
    setInterval(function () { si = (si + 1) % steps.length; steps.forEach(function (s, k) { s.classList.toggle('is-live', k === si); }); }, 2600);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  /* Toggle .is-halloween on the announcement bar while the HALLOWEEN15
     slide is the visible one (the slider flips aria-hidden per slide). */
  (function () {
    document.querySelectorAll('.announcement-bar').forEach(function (bar) {
      var hw = bar.querySelector('[class*="__announcement_halloween"]');
      if (!hw) return;
      function sync() { bar.classList.toggle('is-halloween', hw.getAttribute('aria-hidden') !== 'true'); }
      sync();
      new MutationObserver(sync).observe(hw, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
